import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const AdminSectionBundleReceiptEntry = () => (
  <SectionBundleReceiptEntry
    sectionName="Admin Section"
    sectionDisplayName="Admin Section"
    backRoute="/sections/admin-section"
  />
);

export default AdminSectionBundleReceiptEntry;
